<template>
  <Dialog
    ref="dialog"
    class="new-payout-method-dialog"
    dismissible
    size="medium"
    :title="$gettext('Set up a Payout Method')"
  >
    <div class="dialog-body">
      <p
        v-if="!paymentMethods.length"
        v-translate
      >
        No new payout methods to add, please check back later!
      </p>
      <div
        v-for="method in paymentMethods"
        v-else
        :key="method.title"
        class="payout-method-option items-center"
        tabindex="0"
        @click="$emit(method.eventName)"
        @keydown.enter="$emit(method.eventName)"
      >
        <div :class="`method-image ${method.type}`">
          <img
            :src="String(method.imgSrc)"
            :alt="method.imgAltText"
          >
        </div>
        <div class="method-description text-left">
          <h4>{{ method.title }}</h4>
          <p class="text-body-light">
            {{ method.description }}
          </p>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Getter } from 'vuex-class'
import Dialog from '@/components/CommonUI/Dialog.vue'
import { AccountTypes } from '@/constants'

interface PaymentMethodOption {
  title: string,
  type: string,
  description: string,
  imgSrc: URL,
  imgAltText: string,
  eventName: string,
}

@Options({
  components: {
    Dialog,
  },
})

export default class PayoutMethods extends Vue {
  $refs!: {
    dialog: InstanceType<typeof Dialog>,
  }

  @Getter hasPayoneerAccount!: boolean
  @Getter hasTipaltiAccount!: boolean

  get paymentMethods(): PaymentMethodOption[] {
    const options = []

    if (!this.hasTipaltiAccount) {
      options.push({
        title: this.$gettext('Bank Transfer / Paypal'),
        type: AccountTypes.tipaltiWireTransfer,
        description: this.$gettext('Get paid straight to your bank or paypal account.'),
        imgSrc: new URL('../assets/bank-building.svg', import.meta.url),
        imgAltText: this.$gettext('Bank Transfer / Paypal'),
        eventName: 'tipalti-selected',
      })
    }

    if (!this.hasPayoneerAccount) {
      options.push({
        title: 'Payoneer',
        type: AccountTypes.payoneer,
        description: this.$gettext('Link a Payoneer account for payouts.'),
        imgSrc: new URL('../assets/payoneer-logo.svg', import.meta.url),
        imgAltText: 'Payoneer logo',
        eventName: 'payoneer-selected',
      })
    }

    return options
  }

  show() {
    this.$refs.dialog.show()
  }

  hide() {
    this.$refs.dialog.hide()
  }
}
</script>

<style lang="scss">
.new-payout-method-dialog {
  .payout-method-option {
    display: inline-flex;
    width: 75%;
    padding: 10px;

    @media (--max-medium) {
      width: 100%;
    }
  }
}
</style>
